import { AuthConnection, Connection, getAuthBlobConnection } from "./config.js";

export function getContract(contract_id) {
  return AuthConnection.get(`/contracts/contract/${contract_id}`);
}

export function getContractor(contract_id) {
  return AuthConnection.get(`/contracts/contractor/${contract_id}`);
}

export function getContractorDetails(contract_id) {
  return AuthConnection.get(`/contracts/contractor/${contract_id}/details`);
}

export function changeContractorBasicInfo(contract_id, data) {
  return AuthConnection.post(`/contracts/contractor/${contract_id}/change-basic`, data);
}

export function changeContractorBasicInfoSendEmailCode(contract_id, email) {
  return AuthConnection.post(`/contracts/contractor/${contract_id}/send-code`, { email: email, site:"SMART_LYNN"});
}

export function changeContractorIdentityInfo(contract_id, data) {
  const form = new FormData();

  Object.keys(data).forEach((key) => {
    form.append(key, data[key]);
  });

  return AuthConnection.post(`/contracts/contractor/${contract_id}/change-identity`, form);
}

export function getContractorInfoChangeHistory(contract_id, is_corporate) {
  return AuthConnection.get(`/contracts/contractor/${contract_id}/history?is_corporate=${!!is_corporate}`);
}

export function getContractorIdentityChangeRequest(contract_id) {
  return AuthConnection.get(`/contracts/contractor/${contract_id}/change-identity`);
}

export function getContractorHistoryFile(contract_id, history_seq) {
  return getAuthBlobConnection().get(
    `/contracts/contractor/${contract_id}/history/${history_seq}/file`
  );
}

export function getBankList() {
  return Connection.get(`/bank`);
}

export function getOverpaymentList(contract_id) {
  return AuthConnection.get(`/charges/over-payment/${contract_id}`);
}

export function submitOverpaymentRefund(contract_id, data) {
  const form = new FormData();

  Object.keys(data).forEach((key) => {
    form.append(key, data[key]);
  });

  return AuthConnection.post(`/charges/over-payment/${contract_id}`, form);
}

export function getOptions(contract_id) {
  return AuthConnection.get(`/contracts/options/${contract_id}`);
}

export function getLeaseReceipt(contract_id, year) {
  return AuthConnection.get(`/charges/lease/receipt/${contract_id}/${year}`);
}

export function getLeaseInvoice(contract_id, year, month) {
  return AuthConnection.get(`/charges/lease/invoice/${contract_id}/${year}/${month}`);
}

export function getLeaseDepositInfo(contract_id) {
  return AuthConnection.get(`/charges/lease/deposit/${contract_id}`);
}

export function getSellInvoice(contract_id) {
  return AuthConnection.get(`/charges/sell/invoice/${contract_id}`);
}

export function getSellOptionInvoice(contract_id, query) {
  return AuthConnection.get(`/charges/sell/options/${contract_id}${query === "" ? "" : "?" + query}`);
}

export function getSellOptionItemInvoice(contract_id, optionId, query) {
  return AuthConnection.get(`/charges/sell/option/${contract_id}/${optionId}?${query}`);
}

export function getChargesCalculator(contract_id, query) {
  return AuthConnection.get(`/charges/calculator/${contract_id}?${query}`);
}

export function getLoanApplication(contract_id) {
  return AuthConnection.get(`/contracts/loan/application/${contract_id}`);
}

export function getChargesSellReceipt(contract_id) {
  return AuthConnection.get(`/charges/sell/receipt/${contract_id}`);
}

export function getChargesSellBalance(contract_id, query) {
  return AuthConnection.get(`/charges/sell/balance/${contract_id}?${query}`);
}

export function getLeaseRenew(contract_id, query) {
  return AuthConnection.get(`/contracts/contract/renew/${contract_id}?${query}`);
}

export function getLeaseNewCondition(contract_id) {
  return AuthConnection.get(`/contracts/lease/condition/${contract_id}`);
}

export function getModusignDocs(contract_id) {
  return AuthConnection.get(`/contracts/modusign/${contract_id}/docs`);
}

export function getModusignDownloadUrl(contract_id, doc_id) {
  return AuthConnection.get(`/contracts/modusign/${contract_id}/docs/${doc_id}`);
}

export function getAutoWithdrawAgreement(contract_id) {
  return AuthConnection.get(`/contracts/auto-withdraw/${contract_id}/agreement`);
}

export function getAutoWithdrawHistories(contract_id) {
  return AuthConnection.get(`/contracts/auto-withdraw/${contract_id}/histories`);
}

export function getRentFreeInfo(contract_id) {
  return AuthConnection.get(`/contracts/rent-free/${contract_id}`);
}

export function postPreContract(village_id, data) {
  return AuthConnection.post(`/contracts/pre-contract/${village_id}`, data);
}

export function getVillagesPreContract() {
  return AuthConnection.get(`/villages/pre-contract`);
}

export function getPreContracts() {
  return AuthConnection.get(`/contracts/pre-contract`);
}

export function checkContract() {
  // 1일에 1번만 체크
  // DEV : 임시 disable
  const latest_check_contract = localStorage.getItem("latest_check_contract");
  if (latest_check_contract && new Date(latest_check_contract) > new Date(Date.now() - 1 * 24 * 60 * 60 * 1000)) {
    console.log("이미 체크되었습니다.", latest_check_contract);
    return;
  }
  localStorage.setItem("latest_check_contract", new Date().toISOString());
  return AuthConnection.post(`/contracts/check`);
}
